import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NSSService } from 'app/shared/services/app.service';

declare var opr: any;
declare var InstallTrigger: any;

@Component({
    selector: 'aboutModal',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss']
})
export class AboutModal implements OnInit, OnDestroy {
    @ViewChild('about', {static: true}) public aboutModal; // : ModalDirective;  //modal for validator
    public currentDateTime: string;    
    private modalElement: any;
    public CloseResult: any;
    private modalSubscript;
    public appVersion: string;
    public Browser: string;
    public Server: string;
    constructor( 
        private _nssService: NSSService, 
        private _modalService: NgbModal, 
        ) {
    }

    ngOnInit() {
        this.getBrowser();
        // show the filter modal == Change Filters button was clicked in sidebar
        this.modalSubscript = this._nssService.showAboutModal.subscribe((show: boolean) => {
            if (show) { this.showAboutModal(); }
        });
        this._nssService.getVersion.subscribe((v: string) => {
            this.appVersion = v;
        });
        this.modalElement = this.aboutModal;
        this.updateDateTime();
    }

    private updateDateTime(): void{
        const currentDate = new Date();
        this.currentDateTime = currentDate.toISOString();
    }

    public showAboutModal(): void {
        this._modalService.open(this.modalElement, { backdrop: 'static', keyboard: false, size: 'lg' }).result.then(
            result => {
                // this is the solution for the first modal losing scrollability
                if (document.querySelector('body > .modal')) {
                    document.body.classList.add('modal-open');
                }
                this.CloseResult = `Closed with: ${result}`;
            },
            reason => {
                this.CloseResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) return 'by pressing ESC';
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) return 'by clicking on a backdrop';
        else return `with: ${reason}`;
    }

    ngOnDestroy() {
        this.modalSubscript.unsubscribe();
    }

    private getBrowser() {
        //modified from https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
        // Opera 8.0+
        if ((!!(<any>window).opr && !!opr.addons) || !!(<any>window).opera || navigator.userAgent.indexOf(' OPR/') >= 0) this.Browser = "Opera";
        // Firefox 1.0+
        if (typeof InstallTrigger !== 'undefined') this.Browser = "Firefox";
        // At least Safari 3+: "[object HTMLElementConstructor]"
        if (Object.prototype.toString.call((<any>window).HTMLElement).indexOf('Constructor') > 0) this.Browser = "Safari";
        // Chrome 1+
        if (!!(<any>window).chrome) this.Browser = "Chrome";
        // Edge 20+
        if (!(/*@cc_on!@*/false || !!(<any>document).documentMode) && !!(<any>window).StyleMedia) this.Browser = "Edge";
        // Chromium-based Edge
        if (window.navigator.userAgent.toLowerCase().indexOf('edg/') > -1) this.Browser = "Chromium Edge";
        // Internet Explorer 6-11
        if (/*@cc_on!@*/false || !!(<any>document).documentMode) this.Browser = "IE";
    }
}
